function lazyLoad() {
   document.documentElement.classList.add('loaded');
}
lazyLoad();

function lazyImage(img) {
  var lazyObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
          if (entry.isIntersecting) {
              var lazyImg = entry.target;
              lazyImg.src = lazyImg.dataset.src;
              lazyObserver.unobserve(lazyImg);
          }
      });
  });
  
  lazyObserver.observe(img);
}
var lazyImages = document.querySelectorAll('img[data-src].lazy_img');  
lazyImages.forEach(function(img) {
    lazyImage(img);
});

